import React from 'react';

interface QueryFoldoutItemProps {
  active?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const QueryFoldoutItem = ({ active, onClick, children }: QueryFoldoutItemProps) => (
  <li className={`input-search-query-suggestion-item${active ? ' has-focus' : ''}`}>
    <button type="button" className="input-search-query-suggestion-action" onClick={onClick}>
      {children}
    </button>
  </li>
);

interface QueryFoldoutBlockProps {
  title: string;
  visible?: boolean;
  children?: React.ReactNode;
}

export const QueryFoldoutBlock = ({ title, visible, children }: QueryFoldoutBlockProps) => {
  if (!visible) {
    return null;
  }

  return (
    <>
      <div className="input-search-query-suggestion-heading">{title}</div>
      <ul className="input-search-query-suggestion-list">{children}</ul>
    </>
  );
};
